<template>
  <div :class="['flex', flexDirection, flexItems, flexGapClass, flexJustify]">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

type Props = {
  direction?: 'row' | 'column';
  gap?: number;
  items?: string;
  justify?: string;
};
const props = withDefaults(defineProps<Props>(), {
  direction: 'row',
  gap: 2,
  items: 'center',
  justify: 'start',
});

const flexGapClass = computed(() => `gap-${props.gap}`);
const flexItems = computed(() => `items-${props.items}`);
const flexJustify = computed(() => `justify-${props.justify}`);
const flexDirection = computed(() => (props.direction === 'column' ? 'flex-col' : 'flex-row'));
</script>
